/** Format helpers — locale and currency aware. ALWAYS uses Latin (Western
 *  Arabic) digits 0-9, even when the Arabic locale would normally render
 *  Eastern Arabic digits (٠-٩). The user requirement is: numbers stay in
 *  Latin digits regardless of locale. */

const LATIN: Intl.NumberFormatOptions = { numberingSystem: 'latn' };
const LATIN_DT: Intl.DateTimeFormatOptions = { numberingSystem: 'latn' };

export function formatMoney(amount: number, currency = 'EGP', locale = 'ar-EG'): string {
  try {
    return new Intl.NumberFormat(locale, { ...LATIN, style: 'currency', currency }).format(amount);
  } catch {
    return `${amount.toFixed(2)} ${currency}`;
  }
}

export function formatNumber(value: number, locale = 'ar-EG'): string {
  return new Intl.NumberFormat(locale, LATIN).format(value);
}

export function formatDate(value: Date | string, locale = 'ar-EG'): string {
  const d = typeof value === 'string' ? new Date(value) : value;
  return new Intl.DateTimeFormat(locale, { ...LATIN_DT, dateStyle: 'medium' }).format(d);
}

export function formatTime(value: Date | string, locale = 'ar-EG'): string {
  const d = typeof value === 'string' ? new Date(value) : value;
  return new Intl.DateTimeFormat(locale, { ...LATIN_DT, timeStyle: 'short' }).format(d);
}

export function formatDateTime(value: Date | string, locale = 'ar-EG'): string {
  const d = typeof value === 'string' ? new Date(value) : value;
  return new Intl.DateTimeFormat(locale, {
    ...LATIN_DT,
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(d);
}
